/** @typedef {import("../utils/orderStatus").OrderStatusCode} OrderStatusCode */
import React from "react";
import {ORDER_STATUSES} from "../utils/orderStatus";
import OrderStatusBadge from "./OrderStatusBadge";
import StatusFilter from "../../../shared/components/StatusFilter";

const OPTIONS = ORDER_STATUSES.map(({code, status}) => ({code, node: <OrderStatusBadge status={status} />}));

/**
 * The orders list's status filter: a checkbox per order status, in its color.
 *
 * @param {{
 *   selected: OrderStatusCode[],
 *   onChange: (selected: OrderStatusCode[]) => void,
 * }} props
 */
const OrderStatusFilter = ({selected, onChange}) => (
    <StatusFilter options={OPTIONS} selected={selected} onChange={onChange} />
);

export default OrderStatusFilter;
